export const symbol_status_thai_allergy_kids = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 400,
        Ypos_img: 315,
        width_image:35,
        page: 19,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium longum`,
        Xpos_img: 400,
        Ypos_img: 400,  
        width_image:35,
        page: 19,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 400,
        Ypos_img: 478,
        width_image:35,
        page: 19,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus paracasei`,
        Xpos_img: 400,
        Ypos_img: 560,
        width_image:35,
        page: 19,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus plantarum`,
        Xpos_img: 400,
        Ypos_img: 638,
        width_image:35,
        page: 19,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 400,
        Ypos_img: 717,
        width_image:35,
        page: 19,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
]

export const symbol_status_allergy_kids = [

]